import Model from "../Model";

export default class Contact extends Model {
    get url() {
        return '/api/contacts';
    }
}